require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./en-us-team-in-2023-jack-joined-bic-as-a-policy-associate-he.json") })
        }
      }, "path---en-us-team-in-2023-jack-joined-bic-as-a-policy-associate-he");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---en-us-team-in-2023-jack-joined-bic-as-a-policy-associate-he!./.cache/json/en-us-team-in-2023-jack-joined-bic-as-a-policy-associate-he.json
// module id = 593
// module chunks = 231608221292675